import React from 'react';
import CollectionView from './components/CollectionView';
import TemplateScreen from 'screens/TemplateScreen';

const Collection = () => {
  return (
    <TemplateScreen
      Screen={(eventData, categories, subCategories, categoriesObj) => (
        <CollectionView
          eventData={eventData}
          categories={categories}
          categoriesObj={categoriesObj}
          subCategories={subCategories}
        />
      )}
    />
  );
};

export default Collection;
